import React from 'react';
import { Content, Dialog, DialogContainer, Divider, Heading } from '@adobe/react-spectrum';
import isMobile from 'ismobilejs';
import { UpgradelizerPane } from '../UpgradelizerPane';
import './UpgradeModal.css';

/**
 * Embeds the full Upgradelizer in a dialog, pre-filtered by `preset`, so a
 * diagnostic pane (Synergy, Manabase, Power Levels, …) can drop the user
 * straight into an actionable upgrade search WITHOUT a route/tab switch.
 *
 * The pane runs in `embedded` mode: its filters live in local state instead
 * of the page hash, so opening the modal never disturbs the deck tab behind
 * it. Because the whole pane is reused, the user keeps every control and can
 * refine the search in place — we just hand it a starting point.
 *
 * isDismissable gives an X-close (there's no action ButtonGroup here, so the
 * Spectrum caveat that hides ButtonGroup on dismissable dialogs doesn't bite).
 */
export function UpgradeModal({ isOpen, onClose, preset = null, title = 'Upgrade Finder', origin = null }) {
    const mobile = isMobile(window.navigator).phone;
    return (
        <DialogContainer type="modal" isDismissable onDismiss={onClose}>
            {isOpen && (
                <Dialog
                    UNSAFE_className="upgradeModalDialog"
                    size={mobile ? undefined : 'L'}
                    height={mobile ? 'calc(100vh - 24px)' : '85vh'}
                >
                    <Heading UNSAFE_className="upgradeModalHeading">{title}</Heading>
                    <Divider />
                    <Content UNSAFE_className="upgradeModalContent">
                        <UpgradelizerPane embedded preset={preset} origin={origin} />
                    </Content>
                </Dialog>
            )}
        </DialogContainer>
    );
}
